//nav-mobile-trigger

var hornstrup = hornstrup || {};

hornstrup.mobilenav = hornstrup.mobilenav || function () {
    var self = this;
    var lastRefreshWidth = 0;
    var refreshWidth = 50;

    this.init = function (callback) {
        $('#nav-mobile-trigger').on('click',function (e) {
            if(!$(this).hasClass('has-been-triggered'))
            {
            	e.preventDefault();
            	self.gatherNavigation();
            }
            else{
            	self.showHideMenu();
            }
        });
        $('body').on('click','#nav-mobile-bg',function(){
            $('#nav-mobile-trigger').trigger('click');
        })
    }

    this.gatherNavigation = function(){
    	var nav=$('<div class="nav-mobile-holder"></div>');
    	var navInner=$('<div class="nav-mobile-holder__inner"></div>');
    	var htmlSearch = $('#search-form').clone().attr({'id':'mobile-search','class':'form-search-mobile'});
        $(htmlSearch).find('*').each(function(){

            if($(this).hasClass('form-search__header')){$(this).removeClass('form-search__header').addClass('form-search-mobile__header');}
            else if($(this).hasClass('form-search__input')){$(this).removeClass('form-search__input').addClass('form-search-mobile__input');}
            else if($(this).hasClass('form-search__button')){$(this).removeClass('form-search__button').addClass('form-search-mobile__button');}
            else if($(this).hasClass('form-search__icon')){$(this).removeClass('form-search__icon').addClass('form-search-mobile__icon');}
            else if($(this).hasClass('form-search__input-holder')){$(this).removeClass('form-search__input-holder').addClass('form-search-mobile__input-holder');}

        });
    	var ul=$('<ul class="nav-mobile"></ul>');

    	var htmlNavMain = $('#nav-main').clone();
        var htmlFooterAddress = $('#footer .footer-address').clone();
        var htmlFooterSocial = $('#footer .footer-social').clone();
        var footer=$('<div class="nav-mobile-footer"></div>');

        $(footer).append($(htmlFooterAddress),$(htmlFooterSocial));

    	$(htmlNavMain).children().each(function(){
    		$(this).removeClass('nav-main__item').addClass('nav-mobile__item');
    		if($(this).hasClass('nav-main__item--has-child')){
    			$(this).removeClass('nav-main__item--has-child')//.addClass('nav-mobile__child-trigger');
    		}
    		$(this).find('*').each(function(){
    			if($(this).hasClass('nav-main__item-content')){$(this).removeClass('nav-main__item-content').addClass('nav-mobile__item-content');}

                else if($(this).hasClass('nav-main__link')){$(this).removeClass('nav-main__link').addClass('nav-mobile__link');}
    			else if($(this).hasClass('nav-main__title')){$(this).removeClass('nav-main__title').addClass('nav-mobile__title');}
    			else if($(this).hasClass('nav-main__child-trigger')){$(this).removeClass('nav-main__child-trigger').addClass('nav-mobile__child-trigger');}
    			else if($(this).hasClass('nav-main__svg')){$(this).removeClass('nav-main__svg').addClass('nav-mobile__svg');}
    			else if($(this).hasClass('nav-main__svg--down')){$(this).removeClass('nav-main__svg--down').addClass('nav-mobile__svg--down');}
    			else if($(this).hasClass('nav-main__svg--up')){$(this).removeClass('nav-main__svg--up').addClass('nav-mobile__svg--up');}
    			else if($(this).hasClass('nav-main-level2')){$(this).removeClass('nav-main-level2').addClass('nav-mobile-level2');}
                else if($(this).hasClass('nav-main-level2__item')){$(this).removeClass('nav-main-level2__item').addClass('nav-mobile-level2__item');}
                else if($(this).hasClass('nav-main-level2__link')){$(this).removeClass('nav-main-level2__link').addClass('nav-mobile-level2__link');}
                else if($(this).hasClass('nav-main-level2__title')){$(this).removeClass('nav-main-level2__title').addClass('nav-mobile-level2__title');}

                if($(this).hasClass('nav-main__link--active')){$(this).removeClass('nav-main__link--active').addClass('nav-mobile__link--active');}
                if($(this).hasClass('nav-main__link--selected')){$(this).removeClass('nav-main__link--selected').addClass('nav-mobile__link--selected');}
                if($(this).hasClass('nav-main-level2__link--selected')){$(this).removeClass('nav-main-level2__link--selected').addClass('nav-mobile-level2__link--selected');}

    			//else if($(this).hasClass('xxx')){$(this).removeClass('xxx').addClass('xxxx');}

    		});
    	});
    	var htmlSitelinks = $('#sitelinks').children().clone().each(function(){
            $(this).removeClass('sitelinks__item').addClass('nav-mobile__item');
            $(this).find('a').removeClass('sitelinks__link').addClass('nav-mobile__link').wrap('<span class="nav-mobile__item-content"></span>')
        });



    	$(ul).append($(htmlNavMain).children(),$(htmlSitelinks));
    	$(navInner).append($(htmlSearch),$(ul),$(footer));
    	$(nav).append($(navInner));
    	$('#header').before(nav);
        $('#header').before('<div class="nav-mobile-bg" id="nav-mobile-bg"></div>');
    	$('#nav-mobile-trigger').addClass('has-been-triggered');
    	self.showHideMenu();
    }
    this.showHideMenu = function(){
            $('body').toggleClass('offcanvas-active');
            if( $('body').hasClass('offcanvas-active')){
                if($('.nav-mobile-level2__link--selected').length){
                    $('.nav-mobile-level2__link--selected').first().closest('.nav-mobile__item').children('.nav-mobile__item-content').first().children('.nav-mobile__child-trigger').first().trigger('click');
                }
                $('#nav-mobile-trigger').text('Luk menu');
            }else{
                $('#nav-mobile-trigger').text('Menu');
            }
    }


    // public functions:
    return {
        init: init
    };
}();